import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';

/**
 * Shared open/close state for the Profil-PDF upload popup.
 * Banner, button, and popup component all subscribe — avoids prop drilling
 * across ProfileFreelancer → ProfileBasicView → button.
 */
const useProfilePdfUploadPopup = createGlobalState(() => {
  const isOpen = ref(false);
  const isBannerDismissed = ref(false);
  const openOnProfileVisit = ref(false);

  const open = () => { isOpen.value = true; };
  const close = () => { isOpen.value = false; };
  const dismissBanner = () => { isBannerDismissed.value = true; };
  const resetBannerDismissed = () => { isBannerDismissed.value = false; };
  const requestOpenOnProfileVisit = () => { openOnProfileVisit.value = true; };
  const clearOpenOnProfileVisit = () => { openOnProfileVisit.value = false; };
  const consumeOpenOnProfileVisit = () => {
    const wasRequested = openOnProfileVisit.value;
    openOnProfileVisit.value = false;
    return wasRequested;
  };

  return {
    isOpen,
    open,
    close,
    isBannerDismissed,
    dismissBanner,
    resetBannerDismissed,
    requestOpenOnProfileVisit,
    clearOpenOnProfileVisit,
    consumeOpenOnProfileVisit,
  };
});

export default useProfilePdfUploadPopup;
